import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import LoginForm from './components/LoginForm';
import { useTranslation } from 'react-i18next';
import { useLangUrl } from '../../utilities/useLangUrl';

export default function LogIn() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const { t } = useTranslation();
  const langUrl = useLangUrl()

  useEffect(() => {
    if (Cookies.get('token')) {
      navigate(`${langUrl}/`)
    }
  }, [navigate, langUrl]);

  return (
    <div className='dashboard bg-light-beige col-12 position-relative'>
      <div className='bg-white h-50'></div>
      {loading ?
        <div className="loader" role="status" aria-live="polite" aria-label="Loading"></div>
        :
        <div
          className='dashboard-form container col-10 col-md-6 p-4 bg-dark-orange rounded-4 border border-2 shadow border-white position-absolute top-50 start-50 translate-middle'>
          <h4 className='text-white'>
            {t("login")} <br />
          </h4>
          <LoginForm
            setLoading={setLoading}
            errorMessage={errorMessage}
            setErrorMessage={setErrorMessage}
          />
        </div>
      }
      <div className='d-none d-sm-block col-6 bg-light-beige'>
      </div>
    </div>
  )
}